import { getSessionTicket, getBaseUrl } from '../../../../config';
import { HttpClient } from '../../../../controllers/http-client/http-client';
import { Layer } from '../../../../controllers/http-client/http-client.interfaces';

export function huaweiAuth(next: Layer) {
  return async (req: Request): Promise<Response> => {
    req.headers.set('SessionTicket', getSessionTicket());
    return next(req);
  };
}

export class HuaweiHttpClient extends HttpClient {
  constructor() {
    super(() => getBaseUrl());
    this.use(huaweiAuth);
  }
}

export const client = new HuaweiHttpClient();
